import { ChangeDetectorRef, computed, input } from '@angular/core';
import { CrudManagerService } from '../crud-manager';
import { NgTemplateOutlet, NgClass, NgStyle, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { UiSpinnerComponent } from '@common/ui/frontend-shared/spinner';
import { UiCopyContentComponent } from '@common/ui/frontend-shared/copy-content';
import { NgLetDirective } from '@core/frontend-shared/utils/directives';
import * as i0 from "@angular/core";
import * as i1 from "../crud-manager";
import * as i2 from "@common/ui/frontend-shared/table";
const _c0 = ["crud-table-item", ""];
const _c1 = a0 => [a0];
const _c2 = a0 => ({
  textAlign: a0
});
const _c3 = (a0, a1, a2, a3) => ({
  item: a0,
  col: a1,
  loadingDependencies: a2,
  dependencies: a3
});
function CrudTableItemComponent_ng_template_0_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudTableItemComponent_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-copy-content", 8);
    i0.ɵɵtemplate(1, CrudTableItemComponent_ng_template_0_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    const manualTypeCol_r4 = i0.ɵɵreference(3);
    const autoFieldCol_r5 = i0.ɵɵreference(5);
    const renderFieldCol_r6 = i0.ɵɵreference(7);
    const renderIconCol_r7 = i0.ɵɵreference(9);
    const valueCol_r8 = i0.ɵɵreference(11);
    i0.ɵɵproperty("value", typeof col_r2.copyToClipboard === "function" ? col_r2.copyToClipboard(item_r3) : col_r2.copyToClipboard);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", col_r2.type ? manualTypeCol_r4 : col_r2.render ? renderFieldCol_r6 : col_r2.renderIcon ? renderIconCol_r7 : col_r2.field === "enabled" ? autoFieldCol_r5 : valueCol_r8);
  }
}
function CrudTableItemComponent_ng_template_0_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudTableItemComponent_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudTableItemComponent_ng_template_0_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 9);
  }
  if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().col;
    const manualTypeCol_r4 = i0.ɵɵreference(3);
    const autoFieldCol_r5 = i0.ɵɵreference(5);
    const renderFieldCol_r6 = i0.ɵɵreference(7);
    const renderIconCol_r7 = i0.ɵɵreference(9);
    const valueCol_r8 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngTemplateOutlet", col_r2.type ? manualTypeCol_r4 : col_r2.render ? renderFieldCol_r6 : col_r2.renderIcon ? renderIconCol_r7 : col_r2.field === "enabled" ? autoFieldCol_r5 : valueCol_r8);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "small");
    i0.ɵɵtext(2, "TODO: thumbnail col type not implemented");
    i0.ɵɵelementEnd()();
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵproperty("innerHTML", item_r3[col_r2.field], i0.ɵɵsanitizeHtml);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r3[col_r2.field]));
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, item_r3[col_r2.field]));
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((item_r3[col_r2.field] == null ? null : item_r3[col_r2.field].length) || 0);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵtemplate(1, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_5_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).item;
    const valueCol_r8 = i0.ɵɵreference(11);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c1, item_r3.id));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", valueCol_r8);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_0_Template, 3, 0, "span");
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_1_Template, 1, 1, "span", 10);
    i0.ɵɵconditionalCreate(2, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_2_Template, 3, 3, "span");
    i0.ɵɵconditionalCreate(3, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_3_Template, 3, 3, "span");
    i0.ɵɵconditionalCreate(4, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_4_Template, 2, 1, "span");
    i0.ɵɵconditionalCreate(5, CrudTableItemComponent_ng_template_0_ng_template_2_Conditional_5_Template, 2, 4, "a", 11);
  }
  if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().col;
    i0.ɵɵconditional(col_r2.type === "thumbnail" ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.type === "html" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.type === "date" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.type === "datetime" ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.type === "count" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r2.type === "editlink" ? 5 : -1);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "button", 12);
    i0.ɵɵlistener("click", function CrudTableItemComponent_ng_template_0_ng_template_4_Conditional_0_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r9 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r9.toggleItem($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("icon", item_r3[col_r2.field] ? "check" : "times")("ngClass", item_r3[col_r2.field] ? "ui-button" : "ui-button-grey")("title", ctx_r9.restraints.canToggle !== true ? ctx_r9.restraints.canToggle : "")("disabled", ctx_r9.restraints.canToggle !== true);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_4_Conditional_0_Template, 2, 4, "span");
  }
  if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().col;
    i0.ɵɵconditional(col_r2.field === "enabled" ? 0 : -1);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-spinner", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("size", 20);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", col_r2.render(item_r3, ctx_r9.dependencies), i0.ɵɵsanitizeHtml);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Conditional_0_Template, 1, 1, "ui-spinner", 13);
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Conditional_1_Template, 1, 1, "span", 10);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r9.loadingDependencies ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r9.loadingDependencies ? 1 : -1);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵproperty("innerHTML", col_r2.render(item_r3), i0.ɵɵsanitizeHtml);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_0_Template, 2, 2)(1, CrudTableItemComponent_ng_template_0_ng_template_6_Conditional_1_Template, 1, 1, "span", 10);
  }
  if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().col;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r9.functionRequiresDependencies(col_r2.render) ? 0 : 1);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 14);
  }
  if (rf & 2) {
    const info_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", info_r11.name)("title", info_r11.title || undefined)("color", info_r11.color || undefined);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const info_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("\u00A0\u00A0", info_r11.label);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Conditional_1_Template, 1, 3, "ui-icon", 14);
    i0.ɵɵconditionalCreate(2, CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Conditional_2_Template, 2, 1, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const info_r11 = ctx;
    i0.ɵɵadvance();
    i0.ɵɵconditional((info_r11.name == null ? null : info_r11.name.length) > 0 ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(info_r11.label ? 2 : -1);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_8_Conditional_0_Template, 3, 2, "span");
  }
  if (rf & 2) {
    let tmp_10_0;
    const ctx_r0 = i0.ɵɵnextContext();
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵconditional((tmp_10_0 = col_r2.renderIcon(item_r3)) ? 0 : -1, tmp_10_0);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_10_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵproperty("title", item_r3[col_r2.field]);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3[col_r2.field].length > col_r2.charLimit ? item_r3[col_r2.field].substr(0, col_r2.charLimit) + "..." : item_r3[col_r2.field], " ");
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_10_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const col_r2 = ctx_r0.col;
    const item_r3 = ctx_r0.item;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3[col_r2.field]);
  }
}
function CrudTableItemComponent_ng_template_0_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_ng_template_10_Conditional_0_Template, 2, 2, "span", 15);
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_ng_template_0_ng_template_10_Conditional_1_Template, 2, 1, "span");
  }
  if (rf & 2) {
    const col_r2 = i0.ɵɵnextContext().col;
    i0.ɵɵconditional(col_r2.charLimit ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!col_r2.charLimit ? 1 : -1);
  }
}
function CrudTableItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_ng_template_0_Conditional_0_Template, 2, 2, "ui-copy-content", 8);
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_ng_template_0_Conditional_1_Template, 1, 1, "ng-container");
    i0.ɵɵtemplate(2, CrudTableItemComponent_ng_template_0_ng_template_2_Template, 6, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, CrudTableItemComponent_ng_template_0_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, CrudTableItemComponent_ng_template_0_ng_template_6_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, CrudTableItemComponent_ng_template_0_ng_template_8_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(10, CrudTableItemComponent_ng_template_0_ng_template_10_Template, 2, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const col_r2 = ctx.col;
    i0.ɵɵconditional(col_r2.copyToClipboard ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!col_r2.copyToClipboard ? 1 : -1);
  }
}
function CrudTableItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 6);
    i0.ɵɵelement(1, "ui-spinner");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("colSpan", ctx_r9.tableState().totalColumnCount);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 19);
  }
  if (rf & 2) {
    i0.ɵɵproperty("disabled", true);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 20);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16);
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Conditional_1_Template, 1, 1, "button", 19);
    i0.ɵɵconditionalCreate(2, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Conditional_2_Template, 1, 0, "button", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tableState_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(!tableState_r12.reorderingPermitted ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tableState_r12.reorderingPermitted ? 2 : -1);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_For_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 17);
    i0.ɵɵtemplate(1, CrudTableItemComponent_Conditional_3_ng_template_0_For_2_ng_container_1_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r13 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext(3);
    const itemColumn_r14 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c2, col_r13.align || "left"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemColumn_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction4(5, _c3, ctx_r9.item(), col_r13, ctx_r9.loadingDependencies, ctx_r9.dependencies));
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 22);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1, ctx_r9.item().id))("title", ctx_r9.restraints.canEdit !== true ? ctx_r9.restraints.canEdit : "")("disabled", ctx_r9.restraints.canEdit !== true);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r9 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r9.deleteItem($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("title", ctx_r9.restraints.canDelete !== true ? ctx_r9.restraints.canDelete : "")("disabled", ctx_r9.restraints.canDelete !== true);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "button", 24);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("uiTableContextMenuButton", ctx_r9.item());
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 18);
    i0.ɵɵconditionalCreate(1, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_1_Template, 1, 5, "button", 22);
    i0.ɵɵconditionalCreate(2, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_2_Template, 1, 2, "button", 23);
    i0.ɵɵconditionalCreate(3, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Conditional_3_Template, 1, 1, "button", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tableState_r12 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tableState_r12.showEditButton ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(tableState_r12.showDeleteButton ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r9.enableContextMenu ? 3 : -1);
  }
}
function CrudTableItemComponent_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_0_Template, 3, 2, "td", 16);
    i0.ɵɵrepeaterCreate(1, CrudTableItemComponent_Conditional_3_ng_template_0_For_2_Template, 2, 10, "td", 17, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(3, CrudTableItemComponent_Conditional_3_ng_template_0_Conditional_3_Template, 4, 3, "td", 18);
  }
  if (rf & 2) {
    const tableState_r12 = ctx.$implicit;
    i0.ɵɵconditional(tableState_r12.reorderingEnabled ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(tableState_r12.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(tableState_r12.showButtonCol ? 3 : -1);
  }
}
function CrudTableItemComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudTableItemComponent_Conditional_3_ng_template_0_Template, 4, 2, "ng-template", 7);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngLet", ctx_r9.tableState());
  }
}
// TODO: should not inherit ItemController.
// pass singular itemcontroller via input?
export let CrudTableItemComponent = /*#__PURE__*/(() => {
  class CrudTableItemComponent {
    constructor(cd, crudManager) {
      this.cd = cd;
      this.crudManager = crudManager;
      this.enableContextMenu = false;
      this.item = input(...(ngDevMode ? [undefined, {
        debugName: "item"
      }] : /* istanbul ignore next */[]));
      this.tableState = input(...(ngDevMode ? [undefined, {
        debugName: "tableState"
      }] : /* istanbul ignore next */[]));
      this.loadingState = input(...(ngDevMode ? [undefined, {
        debugName: "loadingState"
      }] : /* istanbul ignore next */[]));
      this.isLoading = computed(() => {
        const item = this.item();
        const loadingState = this.loadingState();
        const isLoading = !item || loadingState.anyLoading && loadingState.ids && loadingState.ids.includes(item.id);
        return isLoading;
      }, ...(ngDevMode ? [{
        debugName: "isLoading"
      }] : /* istanbul ignore next */[]));
      this.loadingDependencies = false;
      this.dependencies = null;
    }
    ngOnInit() {
      if (!this.item() || !this.tableState()) throw new Error('CrudTableItem error: Required Input is missing!');
      this.restraints = this.crudManager.getItemRestraintsInfo(this.item());
    }
    toggleItem(e) {
      this.executeItemAction('toggle', e);
    }
    deleteItem(e) {
      this.executeItemAction('delete', e);
    }
    executeItemAction(action, event) {
      if (event?.stopPropagation) event.stopPropagation();
      this.crudManager.executeItemAction(this.item(), action);
    }
    functionRequiresDependencies(func) {
      return func.length > 1;
    }
    static {
      this.ɵfac = function CrudTableItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrudTableItemComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.CrudManagerService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudTableItemComponent,
        selectors: [["", "crud-table-item", ""]],
        inputs: {
          enableContextMenu: "enableContextMenu",
          item: [1, "item"],
          tableState: [1, "tableState"],
          loadingState: [1, "loadingState"],
          loadingDependencies: "loadingDependencies",
          dependencies: "dependencies"
        },
        attrs: _c0,
        decls: 4,
        vars: 2,
        consts: [["itemColumn", ""], ["manualTypeCol", ""], ["autoFieldCol", ""], ["renderFieldCol", ""], ["renderIconCol", ""], ["valueCol", ""], [1, "loading", 3, "colSpan"], [3, "ngLet"], [3, "value"], [4, "ngTemplateOutlet"], [3, "innerHTML"], [3, "routerLink"], ["type", "button", "uiButton", "", 1, "ui-button-rounded", 3, "click", "icon", "ngClass", "title", "disabled"], [3, "size"], [3, "icon", "title", "color"], [3, "title"], [1, "col-ordering"], [3, "ngStyle"], [1, "col-align-right", "no-wrap"], ["uiButton", "", "icon", "bars", "title", "Zum Aktivieren zuerst nach dieser Spalte sortieren!", 1, "ui-button-outline", 3, "disabled"], ["uiButton", "", "pReorderableRowHandle", "", "icon", "bars", 1, "ui-button-outline"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", "uiButton", "", "title", "Bearbeiten", "icon", "edit", 1, "ui-button-grey", 3, "routerLink", "title", "disabled"], ["e2e-trash-button", "", "type", "button", "uiButton", "", "title", "L\u00F6schen", "icon", "trash", 1, "ui-button-danger", 3, "title", "disabled"], ["type", "button", "uiButton", "", "title", "Actions Menu", "icon", "bars", 1, "ui-button-contrast", 3, "uiTableContextMenuButton"], ["e2e-trash-button", "", "type", "button", "uiButton", "", "title", "L\u00F6schen", "icon", "trash", 1, "ui-button-danger", 3, "click", "title", "disabled"]],
        template: function CrudTableItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CrudTableItemComponent_ng_template_0_Template, 12, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵconditionalCreate(2, CrudTableItemComponent_Conditional_2_Template, 2, 1, "td", 6);
            i0.ɵɵconditionalCreate(3, CrudTableItemComponent_Conditional_3_Template, 1, 1, null, 7);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isLoading() ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.isLoading() ? 3 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, RouterLink, UiButtonComponent, NgClass, UiSpinnerComponent, UiIconComponent, NgLetDirective, i2.ReorderableRowHandle, i2.ContextMenuButton, NgStyle, UiCopyContentComponent, DatePipe],
        styles: [".loading[_ngcontent-%COMP%]{text-align:center;background-color:var(--overlaySoftColor)!important}\n\n/*# sourceMappingURL=crud-table-item.component.ts-angular-inline--77.css.map*/", ".col-align-right[_ngcontent-%COMP%]{text-align:right}\n\n/*# sourceMappingURL=crud-table-item.component.ts-angular-inline--78.css.map*/", ".no-wrap[_ngcontent-%COMP%]{white-space:nowrap;width:1%}\n\n/*# sourceMappingURL=crud-table-item.component.ts-angular-inline--79.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return CrudTableItemComponent;
})();